import { Container, Typography } from "@mui/material";

function Projects() {
  return (
    <Container maxWidth="lg" sx={{ mt: 5 }}>
      <Typography variant="h3" sx={{ mb: 5 }}>
        My projects
      </Typography>
      <Typography variant="body">
        This section is currently in development.
      </Typography>
    </Container>
  );
}

export default Projects;
